const HomeTranslationFr = {
    legal_terms: 'Mentions légales',
    contact: 'Contact',
};

export default HomeTranslationFr;
  